export default {
  modal: null,
  listener: null,
  previousBodyOverflow: null,

  createIframeAndPage(html: Record<string, unknown> | string): { iframe: HTMLIFrameElement; page: HTMLElement } {
    if (typeof html === 'object') {
      html = `All Inertia requests must receive a valid Inertia response, however a plain JSON response was received.<hr>${JSON.stringify(
        html,
      )}`
    }

    const page = document.createElement('html')
    page.innerHTML = html
    page.querySelectorAll('a').forEach((a) => a.setAttribute('target', '_top'))

    const iframe = document.createElement('iframe')
    iframe.style.backgroundColor = 'white'
    iframe.style.borderRadius = '5px'
    iframe.style.width = '100%'
    iframe.style.height = '100%'
    iframe.setAttribute('sandbox', 'allow-scripts')

    return { iframe, page }
  },

  show(html: Record<string, unknown> | string): void {
    const { iframe, page } = this.createIframeAndPage(html)

    this.modal = document.createElement('div')
    this.modal.style.position = 'fixed'
    this.modal.style.width = '100vw'
    this.modal.style.height = '100vh'
    this.modal.style.padding = '50px'
    this.modal.style.boxSizing = 'border-box'
    this.modal.style.backgroundColor = 'rgba(0, 0, 0, .6)'
    this.modal.style.zIndex = 200000
    this.modal.addEventListener('click', () => this.hide())
    this.modal.appendChild(iframe)

    document.body.prepend(this.modal)
    this.previousBodyOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    iframe.srcdoc = page.outerHTML

    this.listener = this.hideOnEscape.bind(this)
    document.addEventListener('keydown', this.listener)
  },

  hide(): void {
    this.modal.outerHTML = ''
    this.modal = null
    document.body.style.overflow = this.previousBodyOverflow ?? ''
    this.previousBodyOverflow = null
    document.removeEventListener('keydown', this.listener)
  },

  hideOnEscape(event: KeyboardEvent): void {
    if (event.keyCode === 27) {
      this.hide()
    }
  },
}
